export enum ButtonVariant {
	OutlinedWithIcon = "OutlinedWithIcon",
	BlackOutlineWithIcon = "BlackOutlineWithIcon",
	Transparent = "Transparent",
	TransparentWithIcon = "TransparentWithIcon",
	OutlinedWithIconTight = "OutlinedWithIconTight",
}

export function getButtonClass(variant: ButtonVariant): string {
	const commonClassesForLargeButtons =
		"relative font-hubot bg-zms-grey ss04 font-medium uppercase overflow-hidden z-10 before:absolute before:bottom-0 before:left-0 before:w-full before:h-0 before:bg-zms-blue before:z-[-1] before:transition-[height] before:duration-300 before:ease-in-out before:rounded-[1.5rem] hover:before:h-full inline-block justify-between font-medium [&>svg]:md:w-[.875rem] [&>svg]:md:h-[.875rem] [&>svg]:w-[.575rem] [&>svg]:h-[.575rem] text-sm md:text-md text-zms-blue py-[.3rem] px-[.9rem] md:py-[.7rem] md:px-[1.4375rem] items-center border border-zms-blue rounded-[1.5rem] transition-[background-color,color,box-shadow] duration-300 ease-in-out hover:bg-zms-blue hover:text-white hover:shadow-[0_20px_25px_-5px_rgba(0,0,0,0.1),0_8px_10px_-6px_rgba(0,0,0,0.1)]";

	const commonClassesForSmallButtons =
		"inline-block justify-between font-medium [&>svg]:h-[1.25rem] cursor-pointer text-[.625rem]/[1] lg:text-[.75rem]/[1] uppercase text-black duration-300 transition-colors hover:bg-zms-grey-100 pt-[.3438rem] pb-[.2938rem] px-[.9375rem] items-center border border-black tracking-[5%] rounded-[1.5rem] min-w-[10rem]";

	switch (variant) {
		case ButtonVariant.OutlinedWithIcon:
			return `${commonClassesForLargeButtons} md:min-w-[12.5rem] min-w-[9rem]`;
		case ButtonVariant.BlackOutlineWithIcon:
			return commonClassesForSmallButtons;
		case ButtonVariant.Transparent:
			return "";
		case ButtonVariant.TransparentWithIcon:
			return "relative inline-block justify-between font-hubot ss04 uppercase [font-stretch:150%] font-normal text-sm/[1.2] lg:text-base/[1.2] text-zms-blue duration-300 transition-colors mb-1 items-center [&>svg]:mb-[-0.0938rem] [&>svg]:w-[.875rem] [&>svg]:h-[.875rem] after:content-[''] after:absolute after:left-1/2 after:-translate-x-1/2 after:bottom-[-4px] after:h-[2px] after:w-[0px] after:bg-zms-blue after:transition-all after:duration-300 hover:after:w-full";
		case ButtonVariant.OutlinedWithIconTight:
			return commonClassesForLargeButtons;
	}
}
